import * as _ from "lodash";
import * as uuidv4 from "uuid/v4";

import { createLinePath, createLineRandom, createRectPath, createRectRandom } from "./path-data";
import { NOTE_SIZE, SLIDE_CONTENT_HEIGHT, SLIDE_HEIGHT, SLIDE_WIDTH } from "../constants";
import { Note, SlidePathData, TemplateData } from "../reducers";
import { textWrap } from "./text-service";
import { findSection, toStoryboardX } from "./template-service";
import { EmptySlide } from "./presentation-store";

export function createSlidePathData(): SlidePathData {
    const bounds = createRectPath(0, 0, SLIDE_WIDTH, SLIDE_HEIGHT, createRectRandom('CLOSED'));
    const separator = createLinePath(10, SLIDE_CONTENT_HEIGHT, SLIDE_WIDTH - 10, SLIDE_CONTENT_HEIGHT, createLineRandom());
    const frame = bounds + separator;
    const lines = _.range(SLIDE_CONTENT_HEIGHT + 75, SLIDE_HEIGHT, 30)
        .map(y => `M20 ${y}H${SLIDE_WIDTH - 20}`)
        .join('');
    return { frame, lines };
}

export function wrapNotes(notes: string): ReadonlyArray<string> {
    const size = SLIDE_WIDTH - 2 * 20;
    const wrapped = textWrap(notes, size, 24);
    return wrapped? wrapped.lines : [];
}

export function setupSlides(template: TemplateData, notes: ReadonlyArray<Note>): ReadonlyArray<EmptySlide> {
    return notes
        .map(note => ({note, section: findSection(template, note)}))
        .filter(({section}) => section !== null)
        .map(({note, section}) => {
            const data = section!.storyboardData;
            return {
                uuid: uuidv4(),
                x: toStoryboardX(template, note.x) + NOTE_SIZE / 2 - SLIDE_WIDTH / 2,
                y: Math.random() * (data.ySeparator - data.yTop - SLIDE_HEIGHT) + data.yTop,
            }
        });
}


// WEBPACK FOOTER //
// ./src/services/slide_helper.ts